import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { DashboardQueryProvider } from './api/query-provider.js';
import { App } from './app.js';
import { SessionProvider } from './session.js';
import './styles.css';

/**
 * Client entry point.
 *
 * The query provider owns the client so it can react to session expiry and
 * clear cached operational data on sign-out. Polling intervals remain set per
 * hook, where the freshness requirement is known.
 *
 * There is no persister and no storage adapter. TanStack Query keeps everything
 * in memory, which is the requirement: a Query Lab result must not survive the
 * tab.
 */
const container = document.getElementById('root');
if (container === null) throw new Error('The #root element is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <SessionProvider>
      <DashboardQueryProvider>
        <App />
      </DashboardQueryProvider>
    </SessionProvider>
  </StrictMode>,
);
